const API_BASE = process.env.REACT_APP_API_BASE || '';

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    ...options,
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.error || `Request failed (${response.status})`);
    error.code = body.code;
    error.status = response.status;
    throw error;
  }
  return body;
}

const jsonOptions = (method, body) => ({
  method,
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});

export const getCurrentUser = () => request('/api/auth/me');
export const login = input => request('/api/auth/login', jsonOptions('POST', input));
export const register = input => request('/api/auth/register', jsonOptions('POST', input));
export const logout = () => request('/api/auth/logout', jsonOptions('POST', {}));
export const getInvitation = token => request(`/api/auth/invite?token=${encodeURIComponent(token)}`);
export const claimWorkspace = input => request('/api/auth/claim', jsonOptions('POST', input));
export const recoverAccount = input => request('/api/auth/recover', jsonOptions('POST', input));
export const changePassword = input => request('/api/auth/change-password', jsonOptions('POST', input));

export const getPracticeSummary = () => request('/api/administration/summary');
export const listTimeEntries = filters => {
  const search = new URLSearchParams(filters || {});
  return request(`/api/administration/time${search.size ? `?${search}` : ''}`);
};
export const createTimeEntry = input => request('/api/administration/time', jsonOptions('POST', input));
export const updateTimeEntry = (entryId, input) => request(`/api/administration/time/${encodeURIComponent(entryId)}`, jsonOptions('PATCH', input));
export const listTeam = () => request('/api/administration/team');
export const createTeamMember = input => request('/api/administration/team', jsonOptions('POST', input));
